import { Helmet } from 'react-helmet'
import DoubleVerticalSlider from './DoubleVerticalSlider'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Double Vertical Slider</title>
    </Helmet>
    <DoubleVerticalSlider />
  </>
)

export default Wrapper
